if (!customElements.get("bundle-display")) {
  customElements.define(
    "bundle-display",
    class BundleDisplay extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        // SETUP PRODUCT RECOMMENDATIONS
        // Get the product recommendations section element
        const productRecommendationsSection = document.querySelector(
          ".product-recommendations"
        );

        // Check if the element exists on the page
        if (productRecommendationsSection) {
          const url = productRecommendationsSection.dataset.url;

          // Check if the URL is available
          if (url) {
            fetch(url)
              .then((response) => response.text())
              .then((text) => {
                const html = document.createElement("div");
                html.innerHTML = text;
                const recommendations = html.querySelector(
                  ".product-recommendations"
                );

                if (
                  recommendations &&
                  recommendations.innerHTML.trim().length
                ) {
                  productRecommendationsSection.innerHTML =
                    recommendations.innerHTML;

                  // setup selection control
                  const bundleRadios = document.querySelectorAll(
                    'input[name="bundle-inputs"]'
                  );

                  // Function to update the selected class
                  const updateSelectedBundle = (selectedProductId) => {
                    // First, remove the selected class from all forms
                    document
                      .querySelectorAll(".bundle-product-form")
                      .forEach((form) => {
                        form.classList.remove("selected-bundle");
                      });

                    // Then, add the class to the matching form
                    const formToSelect = document.querySelector(
                      `.bundle-product-form[data-product-id="${selectedProductId}"]`
                    );
                    if (formToSelect) {
                      formToSelect.classList.add("selected-bundle");
                    }
                  };

                  // Set the initial state: select the first bundle by default
                  if (bundleRadios.length > 0) {
                    bundleRadios[0].checked = true;
                    const firstProductId = bundleRadios[0]
                      .closest(".bundle-product")
                      .getAttribute("data-product-id");
                    updateSelectedBundle(firstProductId);
                  }

                  // Add event listener to each radio button
                  bundleRadios.forEach((radio) => {
                    radio.addEventListener("change", function () {
                      if (this.checked) {
                        const selectedProductId =
                          this.closest(".bundle-product").getAttribute(
                            "data-product-id"
                          );
                        updateSelectedBundle(selectedProductId);
                      }
                    });
                  });

                  // Drop down selector
                  const variantSelectorButtons = document.querySelectorAll(
                    ".custom-select-button-bundle"
                  );
                  if (variantSelectorButtons) {
                    variantSelectorButtons.forEach((button) => {
                      const nearestDropdown = document.querySelector(
                        `[data-product="${button.dataset.productid}"]`
                      );
                      button.addEventListener("click", (event) => {
                        event.stopPropagation(); // Prevent click from bubbling to document
                        const isExpanded =
                          button.getAttribute("aria-expanded") === "true";
                        button.setAttribute("aria-expanded", !isExpanded);
                        nearestDropdown.classList.toggle("active");
                      });
                    });
                  }

                  // control selected variant
                  // Find all the variant <select> elements within the bundle display.
                  const variantSelects = document.querySelectorAll(
                    "bundle-display select"
                  );

                  // If no select elements are found, do nothing.
                  if (!variantSelects.length) {
                    return;
                  }

                  variantSelects.forEach((select) => {
                    select.addEventListener("change", function (event) {
                      // Get the new variant ID from the selected option.
                      const selectedVariantId = event.target.value;

                      // Find the closest parent '.bundle-product' container to get the product ID.
                      const productContainer =
                        event.target.closest(".bundle-product");
                      if (!productContainer) {
                        console.error(
                          "Could not find the parent .bundle-product container."
                        );
                        return;
                      }

                      const productId = productContainer.dataset.productId;

                      // Find the corresponding form using the product ID.
                      // This is the key to linking the <select> to its correct form.
                      const targetForm = document.querySelector(
                        `.bundle-product-form[data-product-id="${productId}"]`
                      );
                      if (!targetForm) {
                        console.error(
                          `Could not find form for product ID: ${productId}`
                        );
                        return;
                      }

                      // Find the hidden input with name="id" within that specific form.
                      const hiddenInput =
                        targetForm.querySelector('input[name="id"]');
                      if (!hiddenInput) {
                        console.error(
                          'Could not find the hidden input[name="id"] in the form.'
                        );
                        return;
                      }

                      // Update the hidden input's value with the new variant ID.
                      hiddenInput.value = selectedVariantId;

                      // Optional: Log to the console to confirm it's working.
                      console.log(
                        `Updated Product ${productId} to Variant ${selectedVariantId}`
                      );
                    });
                  });
                }
              })
              .catch((e) => {
                console.error("Error fetching product recommendations:", e);
              });
          } else {
            console.error(
              "Error: data-url attribute not found on .product-recommendations element."
            );
          }
        } else {
          console.error(
            "Error: .product-recommendations element not found on the page."
          );
        }
      }
    }
  );
}
